<template>
<div class="data-control">
    <div class="page-title">数据监控</div>
    <div class="page-title-bottom-line"></div>
    <div class="main-content-90">
        <div class="controller-container">
            <div class="controller-content">
                <el-cascader class="select-look-obj" placeholder="选择监控对象" :filterable="true" :clearable="true" :options="lookObjArr" v-model="lookObj" @change="selectLookObj">
                </el-cascader>
            </div>
        </div>
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" prop="good_name" label="商品名称" min-width="30%">
                </el-table-column>
                <el-table-column align="center" prop="good_current_num" label="当前库存" min-width="10%">
                </el-table-column>
                <el-table-column align="center" prop="warehouse_name" label="仓库名称" min-width="18.3%">
                </el-table-column>
                <el-table-column align="center" prop="in_store_datetime" label="最近一次进货" min-width="18.3%">
                </el-table-column>
                <el-table-column align="center" prop="in_store_numbers" label="进货数量" min-width="10%">
                </el-table-column>
                <el-table-column align="center" prop="out_store_datetime" label="最近一次出货" min-width="18.3%">
                </el-table-column>
                <el-table-column align="center" prop="out_store_numbers" label="出货数量" min-width="10%">
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    data() {
        return {
            tableData: [],
            lookObjArr: [],
            lookObj: [],
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created () {
        this.init();
        console.log('this.lookObj: ' + this.lookObj)
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 5) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        async init() {
            this.axios.get('monitor_cascade', {
                params: {
                    user_id: this.user.id, 
                }
            })
            .then(async res => {
                this.lookObjArr = res.data.data;
                this.lookObj[0] = res.data.data[0].value;
                this.lookObj[1] = res.data.data[0].children[0].value;
                if(this.userTypeNum == 0) {
                    // this.getLookObjTableData(this.lookObj, 1);
                    let tableData = await this.getDefaultData()
                    this.tableData = tableData;
                }
                else if(this.userTypeNum == 1) {
                    // this.lookObj[0] = res.data.data[0].value;
                    // this.getLookObjTableData(this.lookObj, 2);
                    let tableData = await this.getDefaultData()
                    this.tableData = tableData;
                }
                // 
            })
        },
        async getDefaultData() {
            let requestConfig = {
                url: 'all_monitor_list?user_id=' + this.user.id,
                method: 'get'
            }
            let res = await this.axios(requestConfig);
            return res.data.data;
        },
        getLookObjTableData(lookObj, style) {
            if(lookObj[0] == undefined || lookObj[1] == undefined) {
                return;
            }
            this.axios.get('monitor_list', {
                params: {
                    id: lookObj[1],
                    style: style
                }
            })
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 选择监控对象
        selectLookObj() {
            let style ;
            if(this.userTypeNum == 0) {
                if(this.lookObj[0] == 1) {
                    style = 1;
                }
                else {
                    style = 2;
                }
            }
            else if(this.userTypeNum == 1) {
                style = 2;
            }
            console.log('this.lookobj: ', this.lookObj);
            this.getLookObjTableData(this.lookObj, style)
        },
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.data-control {
    background-color: #F9F9F9;
}
.action-select-first,
.select-look-obj {
    margin-left: 24px;
    width: 161px;
}
.action-select-first {
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataControl/DataControl.vue